"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateInspectionDto = instanceOfCreateInspectionDto;
exports.CreateInspectionDtoFromJSON = CreateInspectionDtoFromJSON;
exports.CreateInspectionDtoFromJSONTyped = CreateInspectionDtoFromJSONTyped;
exports.CreateInspectionDtoToJSON = CreateInspectionDtoToJSON;
exports.CreateInspectionDtoToJSONTyped = CreateInspectionDtoToJSONTyped;
var InspectionTimesDto_1 = require("./InspectionTimesDto");
/**
 * Check if a given object implements the CreateInspectionDto interface.
 */
function instanceOfCreateInspectionDto(value) {
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('inspectionTimes' in value) || value['inspectionTimes'] === undefined)
        return false;
    return true;
}
function CreateInspectionDtoFromJSON(json) {
    return CreateInspectionDtoFromJSONTyped(json, false);
}
function CreateInspectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'listingId': json['listingId'],
        'inspectionTimes': (json['inspectionTimes'].map(InspectionTimesDto_1.InspectionTimesDtoFromJSON)),
    };
}
function CreateInspectionDtoToJSON(json) {
    return CreateInspectionDtoToJSONTyped(json, false);
}
function CreateInspectionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'listingId': value['listingId'],
        'inspectionTimes': (value['inspectionTimes'].map(InspectionTimesDto_1.InspectionTimesDtoToJSON)),
    };
}
